import type IEndPoint from 'interfaces/EndPointTypes.ts';
import BaseURLConfig from '@/common/enum/BaseURLSelection.ts';
import { AuthProtect } from '@/common/enum';

export const getParcelInfo = (data: { county: string; address: string }): IEndPoint => ({
  authorization: AuthProtect.REQUIRED,
  method: 'GET',
  url: `/api/parcels?county=${data.county}&address=${data.address}`,
  defaultBaseURL: BaseURLConfig.DMA,
});

// *: Lookup a single parcel by its Parcel ID (PIN). The PIN is user-typed, so it is
// *: encoded before reaching the query string.
export const getParcelByPin = (pin: string): IEndPoint => ({
  authorization: AuthProtect.REQUIRED,
  method: 'GET',
  url: `/api/parcels?pin=${encodeURIComponent(pin)}`,
  defaultBaseURL: BaseURLConfig.DMA,
});
